/**
 * SH Related Products: Swiper + variant selects; optional Farbe = linked products (custom.products_color).
 */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || (window.KROWN && KROWN.settings && KROWN.settings.shop_money_format) || '';
    if (!formatString || !formatString.match(placeholderRegex)) return String(cents);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number === null) return '0';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : '';
      const iso = (window.KROWN && KROWN.settings && KROWN.settings.iso_code) || '';
      return dollarsAmount + centsAmount + iso;
    }

    let value = '';
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function findVariant(variants, options) {
    return variants.find(function (v) {
      return !v.options.map(function (opt, i) {
        return options[i] === opt;
      }).includes(false);
    });
  }

  function pickDefaultVariant(variants) {
    if (!variants || !variants.length) return null;
    const avail = variants.find(function (v) {
      return v.available;
    });
    return avail || variants[0];
  }

  /** Current [data-sh-related-option] values by option index (before DOM rebuild). */
  function captureOptionSelections(card) {
    const pref = [];
    card.querySelectorAll('[data-sh-related-option]').forEach(function (sel) {
      const idx = parseInt(sel.getAttribute('data-option-index'), 10);
      if (!isNaN(idx)) pref[idx] = sel.value;
    });
    return pref;
  }

  function canonicalValueInList(val, vals) {
    if (val == null || val === '' || !vals || !vals.length) return null;
    const s = String(val);
    let hit = vals.find(function (v) {
      return v === s;
    });
    if (hit != null) return hit;
    const low = s.trim().toLowerCase();
    hit = vals.find(function (v) {
      return String(v).trim().toLowerCase() === low;
    });
    return hit != null ? hit : null;
  }

  /**
   * After linked Farbe swaps product: keep prior size (etc.) when new product still offers that value.
   */
  function pickVariantAfterProductSwap(variants, productOptions, preferred) {
    if (!variants || !variants.length) return null;
    const def = pickDefaultVariant(variants);
    const n = (productOptions && productOptions.length) || 0;
    if (!n) return def;

    const merged = [];
    let i;
    for (i = 0; i < n; i++) {
      const vals = (productOptions[i] && productOptions[i].values) || [];
      const pref = preferred && preferred[i];
      const canon = pref != null && pref !== '' ? canonicalValueInList(String(pref), vals) : null;
      if (canon != null) {
        merged[i] = canon;
      } else if (def && def.options && def.options[i] != null) {
        merged[i] = def.options[i];
      } else if (vals.length) {
        merged[i] = vals[0];
      }
    }

    const v = findVariant(variants, merged);
    return v || def;
  }

  function parseColorData(card) {
    const el = card.querySelector('[data-sh-related-color-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(s) {
    if (s == null) return '';
    const d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function buildMediaFigure(img, sizes, padPct) {
    if (!img || !img.src) {
      return '<span class="sh-related-card__media-placeholder"></span>';
    }
    const fitClass = img.fit ? ' lazy-image-small--fit ' : ' ';
    const pt = padPct != null && String(padPct).trim() !== '' ? String(padPct).trim() : '100';
    const ratioStyle = 'padding-top: ' + pt + '%';
    return (
      '<figure class="lazy-image-small' +
      fitClass +
      '" data-ratio style="' +
      ratioStyle +
      '">' +
      '<img src="' +
      escapeHtml(img.src) +
      '" srcset="' +
      escapeHtml(img.srcset || '') +
      '" alt="' +
      escapeHtml(img.alt || '') +
      '" loading="lazy" sizes="' +
      escapeHtml(sizes || '220px') +
      '" width="' +
      String(img.width || '') +
      '" height="' +
      String(img.height || '') +
      '" onload="this.classList.add(\'lazyloaded\')"' +
      '/></figure>'
    );
  }

  function rebuildVariantSelects(card, productId, options, sectionId, blockId) {
    const wrap = card.querySelector('[data-sh-related-variant-selects]');
    if (!wrap) return;
    if (!options || !options.length) {
      wrap.innerHTML = '';
      return;
    }
    let html = '';
    options.forEach(function (opt, i) {
      const fid = 'sh-rel-' + sectionId + '-' + blockId + '-' + productId + '-opt-' + i;
      html += '<div class="sh-related-card__field">';
      html += '<label class="sh-related-card__label" for="' + escapeHtml(fid) + '">' + escapeHtml(opt.name) + ':</label>';
      html += '<div class="sh-related-card__select-wrap">';
      html += '<select id="' + escapeHtml(fid) + '" class="sh-related-card__select" data-sh-related-option data-option-index="' + i + '" autocomplete="off">';
      (opt.values || []).forEach(function (val) {
        html += '<option value="' + escapeHtml(val) + '">' + escapeHtml(val) + '</option>';
      });
      html += '</select></div></div>';
    });
    wrap.innerHTML = html;
  }

  function syncSelectsToVariant(card, variant) {
    if (!variant) return;
    const selects = card.querySelectorAll('[data-sh-related-option]');
    selects.forEach(function (sel, i) {
      const v = variant.options[i];
      if (v == null) return;
      const match = Array.from(sel.options).find(function (o) {
        return o.value === v;
      });
      if (match) sel.value = match.value;
    });
  }

  function applyColorProduct(card, productId) {
    const list = parseColorData(card);
    if (!list || !list.length) return;
    const item = list.find(function (p) {
      return String(p.id) === String(productId);
    });
    if (!item) return;

    const preferredOptions = captureOptionSelections(card);

    const sectionId = card.getAttribute('data-sh-related-section') || '';
    const blockId = card.getAttribute('data-sh-related-block') || '';
    const sizes = card.getAttribute('data-sh-related-img-sizes') || '220px';
    const pad = card.getAttribute('data-sh-related-media-padding') || '';

    card.setAttribute('data-rel-product-id', String(item.id));

    const mediaLink = card.querySelector('[data-sh-related-media-link]');
    if (mediaLink) {
      mediaLink.setAttribute('href', item.url || '#');
      mediaLink.innerHTML = buildMediaFigure(item.image, sizes, pad);
    }

    const titleA = card.querySelector('[data-sh-related-title-link]');
    if (titleA) {
      titleA.setAttribute('href', item.url || '#');
      titleA.textContent = item.title || '';
    }

    const sub = card.querySelector('[data-sh-related-subline]');
    if (sub) sub.innerHTML = item.sublineHtml || '';

    const vJson = card.querySelector('[data-sh-related-variants]');
    if (vJson) vJson.textContent = JSON.stringify(item.variants || []);

    rebuildVariantSelects(card, item.id, item.options, sectionId, blockId);

    const variants = item.variants || [];
    const chosen = pickVariantAfterProductSwap(variants, item.options, preferredOptions);
    syncSelectsToVariant(card, chosen);

    const input = card.querySelector('[data-sh-related-variant-input]');
    const form = card.querySelector('form[data-type="add-to-cart-form"]');
    const pf = card.querySelector('product-form');

    if (input && chosen) input.value = chosen.id;

    const newFormId = 'sh-rel-product-form-' + sectionId + '-' + blockId + '-' + item.id;
    const newPfId = 'sh-rel-form-' + sectionId + '-' + blockId + '-' + item.id;
    if (form) {
      form.id = newFormId;
      if (chosen && chosen.available) {
        form.classList.remove('disabled-cart');
      } else {
        form.classList.add('disabled-cart');
      }
    }
    if (pf) pf.id = newPfId;

    updateCard(card);
  }

  function updateCard(card) {
    const jsonEl = card.querySelector('[data-sh-related-variants]');
    if (!jsonEl) return;
    let variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    const selects = card.querySelectorAll('[data-sh-related-option]');
    const input = card.querySelector('[data-sh-related-variant-input]');
    const priceEl = card.querySelector('[data-sh-related-price]');
    const btn = card.querySelector('[data-js-product-add-to-cart]');
    const btnText = card.querySelector('[data-js-product-add-to-cart-text]');
    const moneyFormat = window.KROWN && KROWN.settings && KROWN.settings.shop_money_format;

    if (!input || !moneyFormat) return;

    let variant;
    if (!selects.length) {
      variant =
        variants.find(function (v) {
          return String(v.id) === String(input.value);
        }) ||
        pickDefaultVariant(variants) ||
        variants[0];
    } else {
      const options = Array.from(selects).map(function (s) {
        return s.value;
      });
      variant = findVariant(variants, options);
    }

    if (!variant) return;

    input.value = variant.id;

    if (priceEl) {
      let html = formatMoney(variant.price, moneyFormat);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<del class="sh-related-card__compare">' + formatMoney(variant.compare_at_price, moneyFormat) + '</del>';
      }
      priceEl.innerHTML = html;
    }

    if (btn && btnText) {
      if (variant.available) {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('disabled');
        btnText.textContent =
          (window.KROWN && KROWN.settings && KROWN.settings.locales && KROWN.settings.locales.products_add_to_cart_button) ||
          'Add to cart';
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('disabled');
        btnText.textContent =
          (window.KROWN && KROWN.settings && KROWN.settings.locales && KROWN.settings.locales.products_sold_out_variant) ||
          'Sold out';
      }
    }

    const form = card.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      if (variant.available) {
        form.classList.remove('disabled-cart');
      } else {
        form.classList.add('disabled-cart');
      }
    }

    const otherVariantsMsg = card.querySelector('[data-sh-related-other-variants-msg]');
    if (otherVariantsMsg) {
      const anyVariantAvailable = variants.some(function (v) {
        return v.available;
      });
      otherVariantsMsg.hidden = !(variant.available === false && anyVariantAvailable);
    }
  }

  function bindVariantCards(root) {
    root.querySelectorAll('[data-sh-related-card]').forEach(function (card) {
      card.addEventListener('change', function (e) {
        const t = e.target;
        if (t && t.matches && t.matches('[data-sh-related-color-select]')) {
          applyColorProduct(card, t.value);
          return;
        }
        if (t && t.matches && t.matches('[data-sh-related-option]')) {
          updateCard(card);
        }
      });
    });
  }

  function initSwiper(el) {
    if (typeof Swiper === 'undefined') return;
    if (el.classList.contains('swiper-initialized')) return;

    var stack = el.closest('.sh-related-products-stack');
    var nextEl = stack
      ? stack.querySelector('.swiper-button-next')
      : el.querySelector('.swiper-button-next');
    var prevEl = stack
      ? stack.querySelector('.swiper-button-prev')
      : el.querySelector('.swiper-button-prev');
    const slides = el.querySelectorAll('.swiper-slide').length;

    new Swiper(el, {
      slidesPerView: 1.08,
      spaceBetween: 14,
      watchOverflow: true,
      navigation:
        slides > 1 && nextEl && prevEl
          ? {
              nextEl: nextEl,
              prevEl: prevEl,
            }
          : false,
      breakpoints: {
        600: { slidesPerView: 1.15, spaceBetween: 16 },
        900: { slidesPerView: 1.25, spaceBetween: 18 },
      },
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sh-related-swiper]').forEach(initSwiper);
    document.querySelectorAll('.sh-related-products-wrap').forEach(bindVariantCards);
  }

  function boot() {
    if (typeof Swiper === 'undefined') {
      setTimeout(boot, 50);
      return;
    }
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
